/* eslint-disable simple-import-sort/imports */
'use client';

import React from 'react';

import { MessageBubble } from './MessageBubble';
import { type ChatMessage } from '../types';

const TypingIndicator = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '12px 16px',
    color: 'var(--foreground-default)',
    opacity: 0.7
  }}>
    <div style={{
      width: '4px',
      height: '4px',
      backgroundColor: 'currentColor',
      borderRadius: '50%',
      animation: 'typing 1.4s infinite'
    }} />
    <div style={{
      width: '4px',
      height: '4px',
      backgroundColor: 'currentColor',
      borderRadius: '50%',
      animation: 'typing 1.4s infinite 0.2s'
    }} />
    <div style={{
      width: '4px',
      height: '4px',
      backgroundColor: 'currentColor',
      borderRadius: '50%',
      animation: 'typing 1.4s infinite 0.4s'
    }} />
    <style>{`
      @keyframes typing {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-4px); }
      }
    `}</style>
  </div>
);

export type ChatMessageListProps = {
  messages: ChatMessage[];
  isLoading?: boolean;
  isStreaming?: boolean;
  onRetryAssistant?: () => void;
  onEditUser?: (content: string) => void;
  onDeleteUser?: () => void;
  className?: string;
  style?: React.CSSProperties;
  currentUserName?: string;
  currentUserEmail?: string;
  currentUserAvatarUrl?: string | null;
}

export function ChatMessageList({
  messages,
  isLoading = false,
  isStreaming = false,
  onRetryAssistant,
  onEditUser,
  onDeleteUser,
  className = '',
  style,
  currentUserName,
  currentUserEmail,
  currentUserAvatarUrl,
}: ChatMessageListProps) {
  // Determine which assistant message (if any) is currently streaming: the last assistant
  const lastAssistantIndex = (() => {
    for (let i = messages.length - 1; i >= 0; i--) {
      if (messages[i]?.role === 'assistant') return i;
    }
    return -1;
  })();

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style
      }}
    >
      {messages.map((message, idx) => (
        <MessageBubble
          key={`${message.id}-${idx}`}
          message={message}
          isStreaming={isStreaming && message.role === 'assistant' && idx === lastAssistantIndex}
          onRetry={message.role === 'assistant' ? onRetryAssistant : undefined}
          onEdit={message.role === 'user' ? onEditUser : undefined}
          onDelete={message.role === 'user' ? onDeleteUser : undefined}
          allMessages={messages}
          currentUserName={currentUserName}
          currentUserEmail={currentUserEmail}
          currentUserAvatarUrl={currentUserAvatarUrl}
        />
      ))}
      
      {/* Show typing indicator when loading but not streaming */}
      {isLoading && !isStreaming && <TypingIndicator />}
    </div>
  );
}


